import { SearchVehicleByParamsDataProvider } from "./SearchVehicleByParamsDataProvider";
import { SearchVehicleByParamsContainer } from "./components/SearchVehicleByParamsContainer";
import { FindVehicle } from "./load/FindVehicle";
import { LoadBrands } from "./load/LoadBrands";
import { LoadCarCatalog } from "./load/LoadCarCatalog";
import { LoadVehiclesListByCatalog } from "./load/LoadVehiclesListByCatalog";
import { SetSearchParams } from "./load/SetSearchParams";
import { LoadindHandler } from "./load/LoadindHandler";

/**
 * Страница поиска автомобиля по параметрам
 * @returns {JSX.Element}
 */
export const SearchVehicleByParamsPage = () => {

    return (
        <SearchVehicleByParamsDataProvider>
            <SetSearchParams>
                <LoadBrands>
                    <LoadCarCatalog>
                        <LoadVehiclesListByCatalog>
                            <FindVehicle>
                                <LoadindHandler>
                                    <SearchVehicleByParamsContainer />
                                </LoadindHandler>
                            </FindVehicle>
                        </LoadVehiclesListByCatalog>
                    </LoadCarCatalog>
                </LoadBrands>
            </SetSearchParams>
        </SearchVehicleByParamsDataProvider>
    );
};